import styled from 'styled-components';

import { IStyledUnitInputMulti, IStyledUnitInputSpan, IStyledWrapper } from '../index';

export const StyledUnitSpan = styled.span<IStyledUnitInputSpan>`
    font-family: 'Roboto', sans-serif;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    padding-bottom: 5px;
    ${({ theme, filled }) =>
        filled ? `color: ${theme['text-main']} !important` : `color: ${theme['text-secondary-subdued']}`};
`;

export const StyledLabelBox = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    &:nth-child(1) {
        margin-right: 12px;
    }
`;

export const StyledInput = styled.input<IStyledUnitInputMulti>`
    font-family: 'Roboto', sans-serif;
    width: 1ch;
    max-width: 99.99%;
    font-weight: 700;
    font-size: 48px;
    line-height: 56px;
    margin-right: 4px;
    color: ${({ theme }) => theme['text-main']};
    background-color: transparent;
    outline: none;
    text-align: right;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
        display: none;
        -moz-appearance: textfield;
    }

    &:focus ~ ${StyledUnitSpan} {
        color: ${({ theme }) => theme['text-main']};
    }

    &::placeholder {
        color: ${({ theme }) => theme['text-secondary-subdued']};
    }

    &:focus::placeholder {
        opacity: 0;
    }
`;

export const StyledWrapper = styled.div<IStyledWrapper>`
    position: relative;
    display: flex;
    justify-content: center;
    ${({ mb }) => `margin-bottom: ${mb || 48}px;`};
`;

export const StyledHintText = styled.div`
    position: absolute;
    top: 56px;
    left: 0;
    width: 100%;
`;
